module.exports = ":host {\n  min-width: 100vw;\n  min-height: 1px;\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/row-container/mobile/mobile-row-container.styles.scss
// module id = 721
// module chunks = 2